import React from 'react'
import styled from 'styled-components'
import { Link } from '../atoms/Link'

export const PrivacyPolicyDescription = () => {
  return (
    <Description>
      上記またはAirIDにご登録いただいた情報宛にご連絡する場合がございます。当社の
      <Link
        href="https://connect.airregi.jp/doc/privacy.html?150819-1821"
        size={10}
      >
        プライバシーポリシー
      </Link>
      （個人情報保護方針）についてご理解の上送信してください。
    </Description>
  )
}

const Description = styled.div`
  color: #606060;
  font-size: 10px;
  font-weight: 300;
  line-height: 14px;
  text-align: left;
`
